import { displayUSD, sanitizeTotalAmount } from '.';

const displayTotalAmount = (payment) => {
  const amount = sanitizeTotalAmount(
    payment?.pregratuityTotal,
    payment?.mandatedGratuityAmt
  );
  return displayUSD(amount);
};

export { displayTotalAmount };
